// src/App.js
import React from "react";
import { BrowserRouter as Router, Navigate, Route, Routes, useLocation } from "react-router-dom";

import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import ImagePreloader from "./components/ImagePreloader";
import WhatsAppFloat from "./components/WhatsAppFloat";
import ScrollTopButton from "./components/ScrollTopButton";
import Home from "./pages/Home";
import AboutUs from "./pages/AboutUs";
import Events from "./pages/Events";
import ContactUs from "./pages/ContactUs";
import Search from "./pages/search";
import TermsConditions from "./pages/TermsConditions";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import Pharmaceuticals from "./pages/pharma";
import Diagnostics from "./pages/diagnostics";
import MedicalTourism from "./pages/medical-tourism";
import HelayaPharmacy from "./pages/helaya-pharmacy";
import HelayaHeatlthMart from "./pages/HelayaHeatlthMart";
import HelayaDiagnostic from "./pages/HelayaDiagnostic";
import MedicalCenters from "./pages/clinic";
import BrandingDesign from "./pages/amart-design";
import AiSolution from "./pages/AiSolution";
import BarandingAndAiSolution from "./pages/barandingandAisolution";
import HelayaInternational from "./pages/helaya-international";
import Manufacture from "./pages/manufacture";
import Expia from "./pages/exfea";
import Cosmoceutical from "./pages/cosmoceutical";
import HealthcareService from "./pages/HealthcareService";

function AnimatedRoutes() {
  const location = useLocation();

  return (
    <div className="page-fade" key={location.pathname}>
      <Routes>
        <Route path="/a-mart-holdings/*" element={<Navigate to="/" replace />} />

        {/* Main Pages */}
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<AboutUs />} />
        <Route path="/events" element={<Events />} />
        <Route path="/contact" element={<ContactUs />} />
        <Route path="/search" element={<Search />} />
        <Route path="/terms-and-conditions" element={<TermsConditions />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />

        {/* Business Pages */}
        <Route path="/business/pharmaceuticals" element={<Pharmaceuticals />} />
        <Route path="/business/diagnostics" element={<Diagnostics />} />
        <Route path="/business/medical-tourism" element={<MedicalTourism />} />
        <Route path="/business/helaya-pharmacy" element={<HelayaPharmacy />} />
        <Route path="/business/helaya-health-mart" element={<HelayaHeatlthMart />} />
        <Route path="/business/helaya-diagnostic" element={<HelayaDiagnostic />} />
        <Route path="/business/medical-centers" element={<MedicalCenters />} />
        <Route path="/business/branding-design" element={<BarandingAndAiSolution />} />
        <Route path="/business/branding-design-details" element={<BrandingDesign />} />
        <Route path="/business/ai-solution" element={<AiSolution />} />
        <Route path="/business/helaya-international" element={<HelayaInternational />} />
        <Route path="/business/manufacture" element={<Manufacture />} />
        <Route path="/business/expia" element={<Expia />} />
        <Route path="/business/cosmeceutical" element={<Cosmoceutical />} />
        <Route path="/business/healthcare-services" element={<HealthcareService />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </div>
  );
}

function App() {
  const Layout = () => {
    const location = useLocation();
    const hideNavbar =
      location.pathname === "/terms-and-conditions" ||
      location.pathname === "/privacy-policy";

    return (
      <>
        {!hideNavbar && <Navbar />}
        <WhatsAppFloat />
        <ScrollTopButton />

        <main className="main-content">
          <AnimatedRoutes />
        </main>

        <Footer />
      </>
    );
  };

  return (
    <Router>
      <ScrollToTop />
      <ImagePreloader />
      <Layout />
    </Router>
  );
}

export default App;
